import { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

// Static (used often — do not lazy-load)
import DashboardLayout from '../layouts/dashboard';
import { Notifications, MyTasks, OrgTasks } from 'components/dashboard-menu';
import GuaranteeCreation from 'components/request-action/GuaranteeCreation';
import PaperGuaranteeCreation from 'components/request-action/PaperGuaranteeCreation';
import BankDetailsForm from 'components/BankDetailsPage';

// 💡 Dynamic loader wrapper
const Loadable = (Component: React.LazyExoticComponent<any>) => (props: any) => (
  <Suspense
    fallback={
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    }
  >
    <Component {...props} />
  </Suspense>
);

// 📦 Lazy-loaded route pages (heavy files)
const DashboardPage = Loadable(lazy(() => import('pages/dashboard/DashboardPage')));
const AdminPage = Loadable(lazy(() => import('components/admin/team-members/UserPage')));
const Guarantee = Loadable(lazy(() => import('pages/dashboard/GuaranteeViewPage')));
const GuaranteePaper = Loadable(lazy(() => import('pages/dashboard/paper/GuaranteePaperViewPage')));
const EditGuarantee = Loadable(lazy(() => import('pages/dashboard/GuaranteeEditPage')));
const EditPaperGuarantee = Loadable(lazy(() => import('pages/dashboard/paper/GuaranteePaperEditPage')));
const RequestReviewPage = Loadable(lazy(() => import('pages/dashboard/RequestReviewPage')));
const PaperRequestReviewPage = Loadable(lazy(() => import('pages/dashboard/paper/PaperRequestReviewPage')));
const NabLadingPage = Loadable(lazy(() => import('pages/dashboard/NabLandingPage')));
const Legals = Loadable(lazy(() => import('pages/dashboard/Legals')));

export default function Router() {
  return useRoutes([
    {
      path: 'dashboard',
      element: <DashboardLayout />,
      children: [
        { path: 'app', element: <DashboardPage /> },
        { path: 'tasks', element: <MyTasks /> },
        { path: 'org-tasks', element: <OrgTasks /> },
        { path: 'notifications', element: <Notifications /> },
        { path: 'admin', element: <AdminPage /> },
        { path: 'legals', element: <Legals /> },
        {
          path: 'payment',
          element: (
            <BankDetailsForm
              key="bankDetails"
              bsb={'xxxxxx'}
              accountNumber={'xxxxx'}
              billerCode={'xxxxx'}
            />
          )
        },
        { path: 'guarantee/:id', element: <Guarantee /> },
        { path: 'paper/:id', element: <GuaranteePaper /> },
        { path: 'edit/:id', element: <EditGuarantee /> },
        { path: 'editpaper/:id', element: <EditPaperGuarantee /> },
        { path: 'app', element: <DashboardPage /> },
        {
          path: 'request',
          children: [
            { element: <Navigate to="/" replace /> },
            { path: 'create-guarantee', element: <GuaranteeCreation /> },
            { path: 'review-guarantee-request', element: <RequestReviewPage /> },
            { path: 'paper-review-guarantee-request', element: <PaperRequestReviewPage /> },
            { path: 'create-guarantee-applicant', element: <GuaranteeCreation /> },
            { path: 'create-guarantee-beneficiary', element: <GuaranteeCreation /> },
            { path: 'create-paper-guarantee-applicant', element: <PaperGuaranteeCreation /> },
            { path: 'create-paper-guarantee-beneficiary', element: <PaperGuaranteeCreation /> }
          ]
        }
      ]
    },
    { path: 'nab', element: <NabLadingPage /> },
    { path: '/dashboard/legals', element: <Navigate to="/dashboard/app" replace /> }
  ]);
}
